const CATEGORY_ALIASES: Record<string, string[]> = {
  piezometer: ["piezometer"],
  displacement: ["displacement"],
  accelerometer: ["accelerometer"],
  tiltmeter: ["tiltmeter"],
  "resistive strain gauge": ["resistive strain gauge"],
};

/**
 * Categories submitted exclusively via API from an external tool (accelerometer,
 * tiltmeter: NexaWave Device Setup; strain gauge: calibration utility) — neither
 * has a manual input form, so they're excluded from the manual "Start Calibration" flow.
 */
export const HIDDEN_CATEGORIES = [
  "accelerometer",
  "tiltmeter",
  "resistive strain gauge",
];

export const normalizeCategory = (value?: string | null): string =>
  (value ?? "")
    .toString()
    .trim()
    .toLowerCase();

export const matchesCategory = (
  value: string | undefined | null,
  target: string,
  options: { allowPartial?: boolean } = {}
): boolean => {
  const normalized = normalizeCategory(value);
  if (!normalized) return false;

  const aliases = CATEGORY_ALIASES[target] || [target];
  const allowPartial = options.allowPartial ?? true;

  return aliases.some(alias => {
    if (allowPartial && normalized.includes(alias)) return true;
    return normalized === alias;
  });
};

export const getCategoryFromValue = (value?: string | null): string | null => {
  const normalized = normalizeCategory(value);
  if (!normalized) return null;

  for (const category of Object.keys(CATEGORY_ALIASES)) {
    if (matchesCategory(normalized, category)) {
      return category;
    }
  }
  return null;
};

